import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Receipt } from "lucide-react";
import { lazy } from "react";

const NotesDeFraisTab = lazy(() =>
  import("@/features/rh/notes-de-frais/components/NotesDeFraisTab").then((m) => ({
    default: m.default,
  })),
);

export const Route = createFileRoute("/_app/rh/notes-de-frais/")({
  loader: requirePermission(PERMISSIONS.RH.FRAIS?.VIEW || "rh.frais.view"),
  staticData: {
    title: "Notes de Frais",
    icon: Receipt,
    tab_icon: Receipt,
    permission: PERMISSIONS.RH.FRAIS?.VIEW || "rh.frais.view",
    module: "rh",
    section: "Ressources Humaines",
    order: 60,
    showInNav: true,
    showInTab: true,
  },
  component: NotesDeFraisTab,
});
